const baseUrl = process.env.REACT_APP_API_BASE_URL;
const API = {
  //login user Authentication

  AuthenticateUser: `${baseUrl}/api/login`,
  ADUsers: `${baseUrl}/api/adusers`,
  UserRole: `${baseUrl}/api/User/role`,

  //Ship
  shipInfo: `${baseUrl}/api/home/ship/name`,
  ShipDevice: `${baseUrl}/api/home/ship`,
  TestRecordsList: `${baseUrl}/api/home/ship/alcovizor/results`,
  AddCrewMember: `${baseUrl}/api/ship/crewmember`,

  //Crew Search
  SearchCrew: `${baseUrl}/api/home/crews`,
  ExportCrew: `${baseUrl}/api/home/crews/excel`,
  CrewPhoto: `${baseUrl}/api/home/crews/report/photo`,

  //Shipping company
  ShipDetails: `${baseUrl}/api/home/shippingcompany/ships`,
  ShipCompanyList: `${baseUrl}/api/home/shippingCompanyList`,
  ShippingSettings: `${baseUrl}/api/home/shippingcompany/mailalert`,

  //Shipping settings
  SearchSettings: `${baseUrl}/api/home/shippingcompany/shipMailSearch`,
  GetShippingSettings: `${baseUrl}/api/home/shippingcompany/shipMailGet`,
  AddShippingSettings: `${baseUrl}/api/home/shippingcompany/shipMailAddorUpdate`,

  //Mmpl
  MmplDueList: `${baseUrl}/api/home/mmpl/ships/devices/indue`,
  MmplCompanyList: `${baseUrl}/api/home/mmpl/companies`,

  //helpers
  companyNames: `${baseUrl}/api/clientlist`,
  shipNames: `${baseUrl}/api/shiplist`,
  ClientUserlist: `${baseUrl}/api/clientusers`,
  GetAllRank: `${baseUrl}/api/RankAndId`,
  RankExist: `${baseUrl}/api/Rank/Exists`,
  Photo: `${baseUrl}/api/crew/photo`,
  TimeZoneList: `${baseUrl}/api/GetTimeZones`,

  //Download
  DownloadAttachmentAPI: `${baseUrl}/api/attachment/download`,

  //Device Management
  SearchDevice: `${baseUrl}/api/devices`,
  GetDeviceDetails: `${baseUrl}/api/device`,
  PostDevice: `${baseUrl}/api/device`,
  UpdateDevice: `${baseUrl}/api/device`,

  //Crew Management
  SearchCrews: `${baseUrl}/api/crews`,
  GetCrewDetails: `${baseUrl}/api/crew`,
  PostCrew: `${baseUrl}/api/crew`,
  UpdateCrew: `${baseUrl}/api/crew`,

  //Visitor Management
  SearchVisitors: `${baseUrl}/api/VisitorManagement/home/visitors`,
  ExportVisitor: `${baseUrl}/api/VisitorManagement/Visitors/excel`,
  GetVisitorDetails: `${baseUrl}/api/VisitorManagement/visitorDetails`,
  VisitorPhoto: `${baseUrl}/api/home/crews/report/photo`,
  PostVisitor: `${baseUrl}/api/crew`,
  UpdateVisitor: `${baseUrl}/api/VisitorManagement/visitor`,
  CrewIdsList: `${baseUrl}/api/crewmembersList`,

  //Ship Management
  SearchShip: `${baseUrl}/api/ships`,
  GetShipDetails: `${baseUrl}/api/ship`,
  PostShip: `${baseUrl}/api/ship`,
  UpdateShip: `${baseUrl}/api/ship`,

  //calibration due
  GetShipCount: `${baseUrl}/api/DeviceDueCount`,
  SearchCalibration: `${baseUrl}/api/DeviceDueSearch`,
  ExportCalibration: `${baseUrl}/api/DeviceDueExcel`,

  //Client Ship details
  GetClientShipDetails: `${baseUrl}/api/ShipDetails`,

  //Rank Management
  SearchRank: `${baseUrl}/api/Ranks`,
  PostRank: `${baseUrl}/api/Rank`,

  //Mmpl User Management
  SearchMmplUser: `${baseUrl}/api/mmpls`,
  GetMmplUserDetails: `${baseUrl}/api/mmpl`,
  PostMmplUser: `${baseUrl}/api/mmpl`,
  UpdateMmplUser: `${baseUrl}/api/mmpl`,

  // Special Access User Management
  SearchSpecialAccessUser: `${baseUrl}/api/SpecialAccessManagement/specialaccesses`,
  GetSpecialAccessUserDetails: `${baseUrl}/api/SpecialAccessManagement/specialaccess`,
  AddSpecialAccessUser: `${baseUrl}/api/SpecialAccessManagement/add`,
  UpdateSpecialAccessUser: `${baseUrl}/api/SpecialAccessManagement/update`,

  //Staff Management
  SearchStaff: `${baseUrl}/api/shipstaffs`,
  GetStaffDetails: `${baseUrl}/api/shipstaff`,
  PostStaff: `${baseUrl}/api/shipstaff`,
  UpdateStaff: `${baseUrl}/api/shipstaff`,

  //ReportManagement
  GetReport: `${baseUrl}/api/ProcessSearchRequest`,
  AddReport: `${baseUrl}/api/ProcessRequest`,
  DeleteReport: `${baseUrl}/api/ProcessDeleteRequest`,
  DownloadReport: `${baseUrl}/api/ReportDownload`,
  DownloadMonthlyReport: `${baseUrl}/api/MonthlyReport/ReportDownload`,
  GetMonthlyReport: `${baseUrl}/api/MonthlyReport/ProcessSearchRequest`,

  // Compliance / Monthly Report Comments
  SearchComplianceEntry: `${baseUrl}/api/ComplianceEntry/ProcessSearchRequest`,
  GetComplianceEntryDetail: `${baseUrl}/api/ComplianceEntry/GetDetail`,
  SaveComplianceComment: `${baseUrl}/api/ComplianceEntry/SaveComment`,


  //Shipping company
  GetShippingCompanies: `${baseUrl}/api/shippingcompanies`,
  GetShippingCompany: `${baseUrl}/api/shippingcompany`,
  PostShippingCompany: `${baseUrl}/api/shippingcompany`,
  PutShippingCompany: `${baseUrl}/api/shippingcompany`,
  getClientUsers: `${baseUrl}/api/shippingcompany/users`,
  postClient: `${baseUrl}/api/shippingcompany/users`,
  postClientuser: `${baseUrl}/api/shippingcompany/users`,

  //Exist user check
  userExist: `${baseUrl}/api/User/Exist`,

  // IdentityServer
  password: `${baseUrl}/api/ChangePassword`,
};
export default API;
